import React, { useEffect, useRef } from 'react';
import CatergoryCard from './CatergoryCard';
import { Link } from 'react-router-dom';
import BreadCrumb from '../../Common/BreadCrumb/BreadCrumb';
import TopicCard from './TopicCard';
import InfiniteScrollling from '../../Pagination/InfiniteScrollling';
import { CenterLoadingBar, LoadingBar } from '../../loader/loader';
import { useTranslation } from 'react-i18next';
import { Pagination } from 'antd';
import { Modal, ModalHeader } from 'reactstrap';
import ReactPlayer from 'react-player';
import { VideoIcon, PPTIcon, PdfIcon } from '../../../assets/index';
const TopicCategoryDetail = ({
  learndeckStats,
  learnDeckLists,
  count,
  setlearnDeckPage,
  learnDeckPage,
  deckLoading,
  setFlashCardId,
  handleExam,
  openExamPage,
  topicId,
  quizStatus,
  externalVideos,
  totalRecords,
  pageNum,
  mediaPageSize,
  handlePageChange,
  isVideoFetching,
}) => {
  const { t } = useTranslation();
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    if (iframeRef.current) {
      iframeRef.current.contentWindow?.addEventListener(
        'contextmenu',
        handleContextMenu
      );
    }

    return () => {
      if (iframeRef.current) {
        iframeRef.current.contentWindow?.removeEventListener(
          'contextmenu',
          handleContextMenu
        );
      }
    };
  }, []);

  const [videoPlayerOpen, setVideoPlayerOpen] = React.useState(false);
  const [mediaDetails, setMediaDetails] = React.useState(null);
  const [subtitle, setSubTitle] = React.useState([]);
  const [embeddedModalOpen, setEmbeddedModalOpen] = React.useState(false);
  const [embeddedCode, setEmbeddedCode] = React.useState('');

  const handleMediaClick = (media) => {
    let contentType = media.type || 'video'; // Ensure type exists

    if (contentType === 'embedded') {
      setEmbeddedCode(media.embeddedCode || '');
      setEmbeddedModalOpen(true);
    } else if (contentType === 'ppt' || contentType === 'pdf') {
      window.open(
        `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
          media.mediaUrl || media.url
        )}`,
        '_blank',
        'noreferrer'
      );
    } else if (contentType === 'scorm') {
      window.open(media.mediaUrl || media.url, '_blank', 'noreferrer');
    } else {
      setVideoPlayerOpen(true);
      setMediaDetails({
        title: media.title,
        mediaUrl: media.mediaUrl || media.url,
      });

      const subtitleUrl = media.subtitle;
      if (subtitleUrl) {
        let indexVal = subtitleUrl
          .split('/')
          .findIndex((ele) => ele === 'subtitle');
        if (indexVal !== -1) {
          let subtitleFile = subtitleUrl
            .split('/')
            .splice(indexVal + 1)
            .join('/');
          const lang = subtitleFile?.split('_')[1]?.split('.')[0] || 'en';
          const tracks = [
            {
              kind: 'subtitles',
              src: subtitleUrl,
              srcLang: lang,
              default: true,
            },
          ];
          setSubTitle(tracks);
        }
      }
    }
  };

  return (
    <>
      <div className='container category_detail_wrapper '>
        {learndeckStats?.category ? (
          <BreadCrumb
            title='Topic detail page'
            id={5}
            params={{
              category: learndeckStats?.category,
              subject: learndeckStats?.subject,
              topic: topicId,
            }}
          />
        ) : (
          <p className='list_bread'></p>
        )}

        <div className='row detail_row'>
          <div
            className={`col-4 ${
              quizStatus === true && learndeckStats?.goalExist === false
                ? 'col-xl-3 col-lg-4 col-12  detail_left_col detail_left_col-h'
                : learndeckStats?.goalExist === false
                ? 'col-xl-3 col-lg-4 col-12  detail_left_col '
                : learndeckStats?.goalExist === true && quizStatus === true
                ? 'col-xl-3 col-lg-4 col-12  detail_left_col detail_left_col-goals'
                : ''
            }`}
          >
            {deckLoading ? (
              <CenterLoadingBar />
            ) : (
              <CatergoryCard
                data={{
                  progress: learndeckStats?.progressPercent,
                  title: learndeckStats?.title,
                  description: learndeckStats?.description,
                  count: learndeckStats?.decksCount,
                  level: learndeckStats?.learningLevel,
                  colorr: learndeckStats?.categoryColor,
                  levelStatus: learndeckStats?.levelStatus,
                  goalExist: learndeckStats?.goalExist,
                  goalObj: learndeckStats?.goalObj,
                }}
                detail={true}
                level={true}
                button={true}
                handleExam={handleExam}
                openExamPage={openExamPage}
                decks={true}
                temp={true}
                levelStatus={true}
                quizStatus={quizStatus}
              />
            )}
          </div>

          <div className='col-xl-8 col-lg-8 col-12 detail_right_col'>
            <div className='subject_description' title={learndeckStats?.title}>
              {t('LEARN.DECKS_UNDER')}
              {learndeckStats?.title?.length > 25
                ? `${learndeckStats?.title?.slice(0, 25)}...`
                : learndeckStats?.title}{' '}
              ({count ?? 0})
            </div>

            {deckLoading && learnDeckPage === 0 ? (
              <CenterLoadingBar />
            ) : (
              <InfiniteScrollling
                dataLength={learnDeckLists?.length}
                next={() => setlearnDeckPage(learnDeckPage + 1)}
                hasMore={learnDeckLists?.length < count}
                loader={<LoadingBar />}
              >
                <div className='row'>
                  {learnDeckLists?.length
                    ? learnDeckLists.map((data, i) => {
                        return (
                          <div
                            className='col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mb-3'
                            key={i}
                          >
                            <Link to={`/learn/flash-card?deck=${data?._id}`}>
                              <TopicCard data={data} />
                            </Link>
                          </div>
                        );
                      })
                    : ''}
                </div>
              </InfiniteScrollling>
            )}
          </div>
          <div
            className='subject_description'
            style={{
              fontWeight: 'bold',
              color: 'black',
              fontSize: '24px',
              marginTop: '20px',
              marginLeft: '0.5rem',
              marginBottom: '0.5rem',
            }}
          >
            {t('COMMON.EXTERNAL_MEDIA')}
          </div>
          {isVideoFetching ? (
            <CenterLoadingBar />
          ) : externalVideos.length > 0 ? (
            <>
              {externalVideos.map((media) => (
                <div
                  key={
                    media.mediaId ||
                    media.id ||
                    media.mediaUrl ||
                    media.url ||
                    media._id
                  }
                  role='button'
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleMediaClick(media);
                  }}
                  onClick={() => handleMediaClick(media)}
                  className='max__learn-quest-listing-card bg-white'
                  style={{
                    width: 300,
                    cursor: 'pointer',
                    marginBottom: '20px',
                    marginLeft: '10px',
                    marginTop: '10px',
                    borderRadius: '20px',
                    padding: '20px',
                    border: '1px solid #e1e1e1',
                  }}
                >
                  <div className='d-flex flex-column justify-content-center'>
                    {media.type === 'pdf' ? (
                      <div>
                        <PdfIcon.default /> PDF
                      </div>
                    ) : media.type === 'ppt' ? (
                      <div>
                        <PPTIcon.default /> PPT
                      </div>
                    ) : media.type === 'video' ? (
                      <div>
                        <VideoIcon.default /> Video
                      </div>
                    ) : media.type === 'scorm' ? (
                      <div>
                        <PPTIcon.default /> Scorm
                      </div>
                    ) : media.type === 'embedded' ? (
                      <div>
                        <VideoIcon.default /> Embedded
                      </div>
                    ) : (
                      <div>
                        <VideoIcon.default /> Media
                      </div>
                    )}

                    <h4 className='text-overflow-h4 mt-2'>
                      {media?.title || ''}
                    </h4>
                  </div>
                </div>
              ))}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '20px',
                  width: '100%',
                }}
              >
                <Pagination
                  current={pageNum}
                  onChange={handlePageChange}
                  total={totalRecords}
                  pageSize={mediaPageSize}
                />
              </div>
            </>
          ) : (
            <div className='subject_description'>{t('LEARN.NO_EXTERNAL_MEDIA')}</div>
          )}
        </div>
      </div>

      {videoPlayerOpen === true ? (
        <Modal
          isOpen={videoPlayerOpen}
          size='xl'
          className='ml__certs_preview-question-modal-content'
          contentClassName='ml__certs_preview-question-modal'
        >
          <div>
            <ModalHeader className='ml-web_modal-header d-flex '>
              <h4>{mediaDetails?.title}</h4>
              <h6
                role='button'
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setVideoPlayerOpen(false);
                    setMediaDetails(null);
                  }
                }}
                onClick={() => {
                  setVideoPlayerOpen(false);
                  setMediaDetails(null);
                }}
              >
                x
              </h6>
            </ModalHeader>
            <div className='d-flex justify-content-center align-items-center'>
              <ReactPlayer
                config={{
                  file: {
                    attributes: { crossOrigin: 'true' },
                    tracks: subtitle[0]?.src ? subtitle : [],
                  },
                }}
                url={mediaDetails?.mediaUrl}
                controls
                width='100%'
                playing={!!subtitle?.src}
              />
            </div>
          </div>
        </Modal>
      ) : null}
      {embeddedModalOpen ? (
        <Modal
          isOpen={embeddedModalOpen}
          size='xl'
          className='ml__certs_preview-question-modal-content'
          contentClassName='ml__certs_preview-question-modal'
        >
          <div>
            <ModalHeader className='ml-web_modal-header d-flex '>
              <h4>Embedded Media</h4>
              <h6
                role='button'
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setEmbeddedModalOpen(false);
                    setEmbeddedCode('');
                  }
                }}
                onClick={() => {
                  setEmbeddedModalOpen(false);
                  setEmbeddedCode('');
                }}
              >
                x
              </h6>
            </ModalHeader>
            <div
              className='w-100 p-3'
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: embeddedCode }}
            />
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default TopicCategoryDetail;
